<template>
  <div>
    <v-dialog v-model="open" persistent width="800px">
      <v-card class="pa-2">
        <v-layout wrap style="display: flex; align-items: center">
          <v-flex xs8 pa-2>
            <h2>
              {{ localFilters.type === 'transfer_in' ? 'Transfer-in' : 'Transfer-out' }}
            </h2>
            <div>
              <h4 class="grey--text">( Agent: {{ localFilters.admin_id }} )</h4>
            </div>
          </v-flex>
          <v-flex xs4 pa-2 text-xs-right>
            <v-btn flat icon @click="$emit('close')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="items"
            :loading="loading"
            :pagination.sync="pagination"
            class="elevation-1"
            hide-actions
          >
            <template #items="props">
              <tr>
                <td>{{ props.item.ticket_id || '' }}</td>
                <td>
                  {{
                    dayjs(props.item.first_assign_ticket_timestamp).format('DD/MM/YYYY HH:mm') || ''
                  }}
                </td>
                <td>{{ dayjs(props.item.timestamp).format('DD/MM/YYYY HH:mm') || '' }}</td>
                <td>
                  {{
                    filters.type === 'transfer_in' ? props.item.admin_id : props.item.transfer_to
                  }}
                </td>
              </tr>
            </template>
          </v-data-table>

          <v-layout wrap style="display: flex; align-items: center" class="mt-2">
            <v-flex xs6 class="text-xs-left">
              <h4>Total: {{ total }}</h4>
            </v-flex>
            <v-flex xs6 class="text-xs-right">
              <v-pagination
                v-model="pageNumber"
                :total-visible="6"
                :length="pageLength"
                @input="handleChangePage"
              ></v-pagination>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import kmbApi from '@/api/kmb'
import dayjs from 'dayjs'

export default {
  props: {
    filters: {
      type: Object,
      default: () => {}
    },
    dialogOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      open: this.dialogOpen,
      items: [],
      total: 0,
      loading: false,
      pageTemp: 1,
      pageNumber: 1,
      limit: 10,
      offset: 0,
      localFilters: this.filters,
      pagination: { rowsPerPage: -1, sortBy: '' }
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    dayjs() {
      return dayjs
    },
    pageLength() {
      if (this.total) {
        let total = parseFloat(this.total)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    },
    headers() {
      return [
        { text: 'Ticket ID', value: 'ticket_id', sortable: false },
        { text: 'วันที่และเวลาที่สร้าง Ticket', value: 'ticket_create_at', sortable: false },
        { text: 'วันและเวลาที่โอน', value: 'transfer_at', sortable: false },
        {
          text: this.localFilters.type === 'transfer_in' ? 'ได้รับจาก' : 'ส่งต่อให้',
          value: 'agent',
          sortable: false
        }
      ]
    }
  },
  watch: {
    localFilters: {
      deep: true,
      handler() {
        this.handleFetchList()
      }
    }
  },
  mounted() {
    this.localFilters = this.filters
    this.handleFetchList()
  },
  methods: {
    async handleFetchList() {
      const vm = this
      try {
        if (!vm.localFilters) return

        vm.loading = true

        const params = {
          page_id: vm.selectedBot.pageid,
          admin_id: vm.localFilters.admin_id,
          action: vm.localFilters.type,
          start_date: dayjs(vm.localFilters.start_date).format('YYYY-MM-DD'),
          end_date: dayjs(vm.localFilters.end_date).format('YYYY-MM-DD'),
          limit: vm.limit,
          offset: vm.offset
        }

        const response = await kmbApi.getTicketTransferInOutList({ params })

        if (response && response.status === 200) {
          const responseData = response.data.data || []

          vm.items = responseData
          vm.total = response.data.total || 0
        }
      } catch (error) {
        console.error(error)
      } finally {
        vm.loading = false
      }
    },
    handleChangePage(val) {
      const vm = this
      if (vm.pageTemp !== val) {
        vm.pageTemp = val
        vm.offset = vm.pageNumber * vm.limit - vm.limit
        if (vm.pageNumber != 1) {
          vm.offset + 1
        }
        vm.handleFetchList()
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/ticket3/agent-management/customize/Kmb/TicketTransferDetailDialog.vue